import { useEffect, useState } from "react"
import { Button, Col, Form, Row } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import api from "../../../api"

// @ts-ignore
const WalletDetailsTab = ({ customer }) => {
    const { t } = useTranslation()
    const [currentWalletAmount, setCurrentWalletAmount] = useState<number>(0)
    const [newAmount, setNewAmount] = useState<number>(0)

    useEffect(() => {
        api.customer.walletAmount(customer.id).then((r) => {
            // @ts-ignore
            setCurrentWalletAmount(r.data.payload.amount)
        })
    }, [])

    return (
        <div className="card_container row  hidden-md-up mx-0 py-3">
            <Row className="mx-0 my-2 justify-content-between">
                <Col xs={12} sm={12} md={5} lg={5} className="label">
                    <div className="title mb-4 text-muted">{t("Wallet Details")}</div>
                    <Row className="mb-4">
                        <Col xs={6}>
                            <Form.Label className="required">{t("Current Amount")}</Form.Label>
                        </Col>
                        <Col xs={6}>
                            <Form.Control
                                type="text"
                                name="fname"
                                required={true}
                                value={currentWalletAmount}
                                readOnly={true}
                            />
                        </Col>
                    </Row>

                    <Row className="mb-4">
                        <Col xs={6}>
                            <Form.Label className="required">{t("Add Amount")}</Form.Label>
                        </Col>
                        <Col xs={3}>
                            <Form.Control
                                type="text"
                                name="amount"
                                required={true}
                                value={newAmount}
                                onChange={(e) => {
                                    // @ts-ignore
                                    setNewAmount(e.target.value)
                                }}
                            />
                        </Col>
                        <Col xs={3}>
                            <Button
                                disabled={!newAmount || newAmount === 0}
                                onClick={() => {
                                    api.customer.updateWalletAmount(customer.id, newAmount).then((r) => {
                                        // @ts-ignore
                                        setCurrentWalletAmount(r.data.payload.amount)
                                        setNewAmount(0)
                                    })
                                }}
                                className="btn btn-primary">
                                {t("Add")}
                            </Button>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </div>
    )
}

export default WalletDetailsTab
